module.exports = __webpack_public_path__ + "assets/adpoly-it-software-bulk-upload-template.84de96ce.xlsx";